module.exports = __webpack_public_path__ + "img/riro_token.rwax.ae323cc.png";